// Shared Leaflet helpers — geofences are stored either as [[lat, lng], ...]
// or as [{lat, lng}, ...] (auto-clipped zones use the object form), so every
// polygon is normalized before it reaches react-leaflet.

export const normalizeLatLng = (p) => {
  if (Array.isArray(p) && p.length >= 2) {
    const [lat, lng] = p;
    return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
  }
  if (p && typeof p === 'object') {
    const lat = Number(p.lat);
    const lng = Number(p.lng ?? p.lon);
    return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
  }
  return null;
};

export const isValidLatLng = (p) => normalizeLatLng(p) !== null;

export const safePolygonPositions = (polygon) =>
  (Array.isArray(polygon) ? polygon : []).map(normalizeLatLng).filter(Boolean);

export const isValidPolygon = (gf) =>
  !!gf && Array.isArray(gf.polygon) && safePolygonPositions(gf.polygon).length >= 3;
